import React, { useRef, useEffect, useState } from "react";
import "@toast-ui/editor/dist/toastui-editor.css";
import { Editor } from "@toast-ui/react-editor";
import { Link, useParams, useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import moment from "moment";
import SubHeader from "../components/subHeader3";
import SubHeader2 from "../components/subHeader4";

export default function TextEditor() {
  // Editor DOM
  const editorRef = useRef();
  const location = useLocation();
  const navigate = useNavigate();
  console.log(location);

  const [value, setValue] = useState("");
  const [subject, setSubject] = useState(location.state.subject);
  const [fileArray, setArray] = useState([]);
  const [imgLink, setImgLink] = useState(location.state.imgLink);
  const { board } = useParams();
  const boardName=board;
  const [header, setHeader] = useState("");
  const [isloggedIn, setLoggedIn] = useState(false);

  const board_id = location.state.board_id;
  const content = location.state.content;
  console.log(location.state);
  const subjectChange = (event) => {
    setSubject(event.target.value);
  };
  let files = [];
  useEffect(() => {
    if (board === "pr") {
      setHeader("홍보자료");
    } else if (board === "news") {
      setHeader("활동사항");
    } else {
      setHeader("인재채용");
    }
  }, []);
  const deletePicButton = () => {
    axios
      .delete("https://thegmmedical.com:5002/deletepic", {
        data: {
          // 서버에서 req.body.{} 로 확인할 수 있다.
          file_name: files,
        },
      })
      .then(() => this.setState({ status: "Delete successful" }));
  };
  // 등록 버튼 핸들러
  const handleRegisterButton = () => {
    var arrayLength = fileArray.length;
    console.log(arrayLength);
    var extractStr = editorRef.current?.getInstance().getMarkdown();
    for (var i = 0; i < arrayLength; i++) {
      let result = extractStr.match(fileArray[i]);
      console.log("result: " + result);
      if (result == null) {
        var filename = fileArray[i].substring(
          fileArray[i].lastIndexOf("/") + 1
        );

        axios
          .delete("https://thegmmedical.com:5002/deletepic", {
            data: {
              // 서버에서 req.body.{} 로 확인할 수 있다.
              file_name: filename,
              board_name: boardName,
            },
          })
          .then(() => this.setState({ status: "Delete successful" }));
      }
      //Do something
    }

    // 입력창에 입력한 내용을 HTML 태그 형태로 취득
    console.log(editorRef.current?.getInstance().getHTML());
    const date_time = moment(new Date()).format("YYYY-MM-DD h:mm:ss");
    const board = {
      content: editorRef.current?.getInstance().getHTML(),
      content_txt: editorRef.current
        ?.getInstance()
        .getHTML()
        .replace(/<\/?[^>]+(>|$)/g, ""),
      date_time: date_time,
      subject: subject,
      img_link: imgLink,
      board_id: board_id,
      board_name: boardName,
    };
    fetch("https://thegmmedical.com:5002/api/boardupdate", {
      method: "post", // 통신방법
      headers: {
        "content-type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify(board),
    })
      .then((res) => res.json())
      .then((json) => {
        console.log(json);
      });
      window.location.href = 'https://thegmmedical.com/'+boardName+ "/view/" + board_id;
  };

  return (
    <div>
      {header === "인재채용" && <SubHeader2 />}
      {header !== "인재채용" && <SubHeader />}
      <h1 className="headerText">{header}</h1>
      <div className="write_wrapper">
        <form id="write-form" noValidate>
          <div className="formRow">
            <div className="col col_title">
             
              <input
                type="text"
                name="name"
                className="formInput"
                placeholder="제목을 입력하세요."
                onChange={subjectChange}
                value={subject}
              ></input>
            </div>
          </div>
          <div className="formRow">
            <div>
              <Editor
                ref={editorRef}
                initialValue={content}
                previewStyle="vertical"
                height="300px"
                onChange={setValue}
                initialEditType="wysiwyg"
                //toolbarItems={[['bold', 'italic', 'strike'], ['image']]}

                // hooks 에서 addImageBlobHook 를 주물러 주면 된다.
                hooks={{
                  addImageBlobHook: async (blob, callback) => {
                    console.log(blob.size);
                    if (blob.size > 5000000) {
                      alert(
                        "업로드에 실패했습니다. 이미지당 5MB까지 업로드할 수 있습니다."
                      );
                      return;
                    }
                    // File {name: '카레유.png', ... }
                    const formData = new FormData();
                    formData.append("img", blob);
                    // 1. 첨부된 이미지 파일을 서버로 전송후, 이미지 경로 url을 받아온다.
                    // const imgUrl = await .... 서버 전송 / 경로 수신 코드 ...
                    await axios.post(
                      "https://thegmmedical.com:5002/api/img?board=" + board,
                      formData
                    ).then(( res ) => {
                      console.log(res);
                      console.log(
                        "성공 시, 백엔드가 보내주는 데이터",
                        res.data.url
                      );
  
                      const IMG_URL = res.data.url;
                      setImgLink(IMG_URL);
                      // 2. 첨부된 이미지를 화면에 표시(경로는 임의로 넣었다.)
                      callback(IMG_URL, "test");
                      //alert(IMG_URL);
                      files.push(IMG_URL);
                      setArray(files);
                      //setArray((fileArray) => [...fileArray, IMG_URL]);
                      //alert("fileArray: ", files);
                      console.log(files);
                      var arrayLength = files.length;
                      //alert(arrayLength);
                      //alert("end");
                    
                    });
                  },
                }}
              ></Editor>
            </div>
          </div>
        </form>
        <div
          style={{
            marginTop: "40px",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <Link to={"/" + boardName} id="toList">
            {" "}
            <div className="btn_list">목록으로</div>
          </Link>
          <div className="btn_write" onClick={handleRegisterButton}>
            글 작성
          </div>
        </div>
      </div>
    </div>
  );
}
